// extracted by mini-css-extract-plugin
module.exports = {"text-gradient":"Chart_text-gradient__3GwLw","chartInfo":"Chart_chartInfo__2yanN","averageValue":"Chart_averageValue__3Qipf"};